/**
 * Site-wide maintenance switch.
 *
 * true  — every page redirects to /maintenance
 * false — the site works normally
 *
 * Change this value, save, and reload.
 */
export const MAINTENANCE_MODE = true;
